import * as React from "react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { SkeletonCircle, Flex } from "@chakra-ui/react"
import { SkeletonProps } from "./skeleton.intarface"

export const MessageSkeleton: React.FC<SkeletonProps> = ({
  containerProps,
  offFade,
  isSmallView
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Flex
      marginBottom="0.5rem"
      opacity="100%"
      border="2px solid"
      borderColor={roomStyles?.servicePanelElementBorder ?? "#E2E8F0"}
      borderRadius="0.6rem"
      padding="0.3rem"
      background={roomStyles?.servicePanelElementBackground ?? "white"}
      width={isSmallView && "150px"}
      style={{ ...containerProps }}
    >
      <SkeletonCircle
        size="5"
        margin="0.1rem 0rem 0rem 0.1rem"
        startColor={"#687786"}
        endColor={offFade ? "#687786" : "white"}
      />
      <Flex flexDirection="column" marginBottom="0.2rem">
        <Flex
          height="8px"
          width="50px"
          marginLeft="0.33rem"
          marginTop="0.2rem"
          backgroundColor={"#687786"}
        />
        <Flex
          height="8px"
          width={isSmallView ? "80px" : "100px"}
          marginLeft="0.33rem"
          marginTop="1rem"
          backgroundColor={"#687786"}
        />
      </Flex>
      <Flex
        marginLeft="auto"
        marginRight="0.1rem"
        flexDirection="column"
        justifyContent="space-between"
        marginBottom="0.2rem"
      >
        <Flex
          height="8px"
          width="25px"
          marginTop="0.2rem"
          backgroundColor={"#687786"}
        />
        <SkeletonCircle
          size="0.7rem"
          marginLeft="auto"
          startColor={"#687786"}
          endColor={offFade ? "#687786" : "white"}
        />
      </Flex>
    </Flex>
  )
}
